// eslint-disable-next-line import/prefer-default-export
export enum COLOR {
  Primary = 'primary',
  Default = 'default',
  Warning = 'warning',
  Danger = 'danger',
}
